import { Flex, Select } from '@chakra-ui/core'
import useLocaleText from 'components/useLocaleText'
import React, { useState, useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { SettingItem } from './SettingItem'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'

const DEFAULT_REWORK_LIMIT = 3
const MIN_REWORK_LIMIT = 1
const MAX_REWORK_LIMIT = 10

interface FeedbackLimitSwitchProps {
  number: number
}

export const FeedbackLimitSwitch: React.FC<FeedbackLimitSwitchProps> = ({ number }) => {
  const { control, watch, setValue } = useFormContext()

  const t_reworkLimit = useLocaleText('rework_limit') || 'Rework limit'

  // Local state for switch (does NOT go to payload)
  const [isEnabled, setIsEnabled] = useState(false)

  // Watch rework_limit to sync switch state on mount (for edit mode)
  const reworkLimitValue = watch('rework_limit')

  const handleSwitchChange = (checked: boolean) => {
    setIsEnabled(checked)
    if (!checked) {
      setValue('rework_limit', null)
    } else {
      setValue('rework_limit', DEFAULT_REWORK_LIMIT)
    }
  }

  useEffect(() => {
    if (reworkLimitValue !== null && reworkLimitValue !== undefined) {
      setIsEnabled(true)
    }
  }, [reworkLimitValue])

  return (
    <SettingItem
      number={number}
      title={t_reworkLimit}
      control={
        <Flex alignItems="center" style={{ columnGap: '10px' }}>
          <Controller
            name="rework_limit"
            control={control}
            defaultValue={null}
            as={
              <Select
                width="100%"
                maxWidth="120px"
                height="32px"
                textAlign="center"
                border="none"
                boxShadow="0px 2px 6px 0px #dcdcdc"
                borderRadius="7px"
                isDisabled={!isEnabled}
                opacity={isEnabled ? 1 : 0.5}
                cursor={isEnabled ? 'pointer' : 'not-allowed'}
                _focus={{
                  boxShadow: '0px 2px 6px 0px #dcdcdc',
                  outline: 'none',
                }}
              >
                {Array.from({ length: MAX_REWORK_LIMIT - MIN_REWORK_LIMIT + 1 }, (_, i) => i + MIN_REWORK_LIMIT).map(
                  (num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  )
                )}
              </Select>
            }
          />
          <ControlledCustomSwitch
            size="lg"
            isChecked={isEnabled}
            onChange={(e) => handleSwitchChange(e.target.checked)}
          />
        </Flex>
      }
    />
  )
}
